<div class="map h-100">
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3489.575891512157!2d77.00516600000002!3d28.999936000000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390dba9c71073183%3A0x9707fea5dc292c67!2sHindu%20Senior%20Secondary%20School!5e0!3m2!1sen!2sin!4v1732542359381!5m2!1sen!2sin"
        width="100%" height="100%" style="border:0;border-radius: 10px;z-index: 1100;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>